// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useState } from 'react';
import { GetAdviceButton } from '../components/GetAdviceButton';
import { OpenAiWidget } from '../components/OpenAiWidget';
import { CompanyLogo, Clock, ShieldCheck } from '../components/constants';
import { OpenAiHeader } from '../components/OpenAiHeader';
import * as styles from '../styles/OpenAiView.styles';

type OpenAiViewProps = {
  candidateName: string;
  interviewRef: string;
};

export const OpenAiView = ({ candidateName, interviewRef }: OpenAiViewProps): JSX.Element => {
  if (!interviewRef) {
    throw new Error('interviewRef is not set');
  }
  const [isOpen, setIsOpen] = useState(false);
  const displayName = candidateName?.trim() || 'Catherine';

  return (
    <>
      <div style={styles.pageWrapperStyle}>
        <OpenAiHeader />
        <div style={styles.contentOuterStyle}>
          <div style={styles.mainCardContainerStyle}>
            <div style={styles.flexColumnStyle}>
              <div style={styles.interviewHeaderRowStyle}>
                <div style={styles.companyRowStyle}>
                  {/* <CompanyLogo /> */}
                  <div style={styles.roleTextWrapperStyle}>
                    <p style={styles.introTitleStyle}>Initial Interview</p>
                    <h4 style={styles.introRoleStyle}>Senior Software Engineer</h4>
                  </div>
                </div>
              </div>

              {!isOpen && (
                <div style={styles.welcomeContainerStyle}>
                  <div style={styles.welcomeLeftStyle}>
                    <h2 style={styles.welcomeTitleStyle}>Welcome, {displayName}!</h2>
                    <p style={styles.welcomeDescStyle}>
                      {' '}
                      Thank you for your interest in the Senior Software Engineer role at Capsule. This first
                      conversation is an opportunity for us to learn more about your background and experience. I'll ask
                      you some basic questions. Please answer them to the best of your ability providing as much detail
                      as possible. <br />
                      <br />
                      Start the interview now
                    </p>
                    {!isOpen && <GetAdviceButton setIsOpenCallback={setIsOpen} />}
                  </div>

                  <div>
                    <div style={styles.welcomeInfoRowStyle}>
                      <div style={styles.iconInfoRowStyle}>
                        <Clock />
                        <div>
                          <h4 style={styles.infoTitleStyle}>Expect to spend ~25 minutes</h4>
                          <p style={styles.infoDescStyle}>Very short interviews may not be considered complete.</p>
                        </div>
                      </div>

                      <div style={styles.iconInfoRowStyle}>
                        <ShieldCheck />
                        <div>
                          <h4 style={styles.infoTitleStyle}>Your data is secure</h4>
                          <p style={styles.infoDescStyle}>Your answers are only for evaluating your candidacy.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {isOpen && (
                <div style={styles.aiContainerStyle}>
                  <OpenAiWidget setIsOpenCallback={setIsOpen} interviewRef={interviewRef} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
